import { inject, watch } from 'vue'

export default store => {
  const $axios = inject('$axios')
  const { accessToken } = store

  watch(() => accessToken.value, async token => {
    // If token found in store, set authorization header to Bearer Token. Else null.
    $axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null
  })
}
